import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getActivityDetails,
  clearActivityDetails,
} from "../../API/store/actions/projects/projects";
import { useParams } from "react-router-dom";
import Loading from "../reusableComponents/loadingScreens";
import { resolver } from "../../API/middlewares/resolveRequests";
import ActivityComments from "./activityComments";
import ActivityDetails from "./activityDetails";
import { ScrollToTop } from "../../algorithms";

const ActivityDetailsIndex = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [displayComments, setDisplayComments] = useState({
    display: false,
    id: null,
    content: [],
    owner: {},
  });

  const [procAdded, setProcAdded] = useState(false);
  const [activityDetails, setActivityDetails] = useState({});
  const { id } = useParams();
  const userToken = useSelector((state) => state.login.userToken);
  const reload = useSelector((state) => state.reload.reload);

  useEffect(() => {
    if (activityDetails) setActivityDetails({});
    resolver(getActivityDetails, setActivityDetails, parseInt(id), userToken);
    ScrollToTop();
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => {
      clearActivityDetails();
      window.removeEventListener("resize", handleResize);
    };
  }, [windowDimensions, procAdded, reload]);

  if (activityDetails?.data) {
    return (
      <>
        <div className="d-flex flex-column align-items-center align-items-sm-start col-xl-8 col">
          <ActivityDetails
            activityDetails={activityDetails}
            commentsUnderProcedure={
              windowDimensions.width <= 1200 ? true : false
            }
            displayComments={displayComments}
            setDisplayComments={setDisplayComments}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />
        </div>

        {windowDimensions.width > 1200 && displayComments.display ? (
          <ActivityComments
            activityDetails={activityDetails}
            displayComments={displayComments}
            setDisplayComments={setDisplayComments}
          />
        ) : null}
      </>
    );
  } else
    return (
      <div>
        <Loading />
      </div>
    );
};

export default ActivityDetailsIndex;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
